module.exports = __webpack_public_path__ + "img/1_028.13e23f09.jpg";